




















































































































import BaseComponent from '@/components/base-component.vue';
import VisitPlanningForm from '@/components/crm/visit-planning/visit-planning-form.vue';
import VisitFilters from '@/components/crm/visit/visit-filters.vue';
import VisitForm from '@/components/crm/visit/visit-form.vue';
import VisitResultDialog from '@/components/crm/visit/visit-result-dialog.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiTableContainer from '@/components/UI/table-container.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { RegistroVisitaFiltroDTO } from '@/interfaces/crm-visit';
import * as service from '@/services/crm-visit';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    VisitForm,
    UiFilterContainer,
    UiTableContainer,
    UiToggleStatus,
    VisitFilters,
    VisitResultDialog,
    VisitPlanningForm
  }
})
export default class Visit extends BaseComponent {
  public formOpen: boolean = false;
  public edit: boolean = false;

  idSelected = null;
  filter: any = {};

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;

  openResultDialogFlag = false;
  result = null;
  formPlanningOpen = false;

  public headers: any = [
    { text: 'Instituição', value: 'inst.nomeFantasia', sortable: true },
    { text: 'Visitado em', value: 'data', sortable: true },
    { text: 'Modalidade', value: 'presencial', sortable: true },
    { text: 'Agendamento', value: 'agendamento.id', sortable: true },
    { text: 'Alterado por', value: 'loginAlteracao', sortable: true },
    { text: 'Alterado em', value: 'dataAlteracao', sortable: true },
    { text: '', value: '', sortable: false, width: '30' }
  ];

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.load();
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listCrmVisit(filter);
        })
      )
      .subscribe(
        (res) => {
          this.items = res.content;
          this.loading = false;
          this.pagina = res;
          PaginationSyncDTO.update(this.pagination, res);
        },
        (error) => {
          this.loading = false;
          this.showToastApiError(error);
        }
      );
  }

  newItem() {
    this.idSelected = null;
    this.formOpen = true;
    this.edit = true;
  }

  openItem(item, edit) {
    this.idSelected = item.id;
    this.formOpen = true;
    this.edit = edit;
  }

  onCloseForm() {
    this.formOpen = false;
  }

  onAfterSave(res) {
    this.formOpen = false;
    this.load();
    this.openResultDialog(res);
  }

  public onFilter(value): void {
    this.filter = value;
    this.pagination.page = 1;
    if (this.filter.sortBy) {
      this.pagination.descending = this.filter.descending;
      this.pagination.sortBy = this.filter.sortBy;
    }
    this.load();
  }

  onChangeFilter() {
    this.load();
  }

  load() {
    this.items = [];
    this.loading = true;

    let parm = new RegistroVisitaFiltroDTO();
    parm.idsInstituicoes = this.filter.idsInstituicoes ? this.filter.idsInstituicoes : null;
    parm.dataIni = this.filter.datas && this.filter.datas.length == 2 ? this.filter.datas[0] : null;
    parm.dataFim = this.filter.datas && this.filter.datas.length == 2 ? this.filter.datas[1] : null;
    parm.idsVisitantes = this.filter.idsVisitantes;
    parm.idsContatos = this.filter.idsContatos;
    parm.comAgendamento = this.filter.comAgendamento;
    parm.participacao = this.filter.participacao;
    parm.presencial = this.filter.presencial;
    parm.update(this.pagination);
    this.execBehaviorSub$.next(parm);
  }

  @Watch('pagination')
  private onChangePagination() {
    this.load();
  }

  public deleteItem(item): void {
    const deleteAction = () => {
      this.loader.start('Processando... ');
      service.deleteCrmVisit(item.id).subscribe(
        (res) => {
          this.loader.stop();
          this.toast.show('Agendamento excluído com sucesso', 'success');
          this.load();
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        }
      );
    };

    this.dialog.show(
      'error',
      'Exclusão de registro',
      `Deseja excluir o registro de visita na instituição ${item.instituicao}, data ${item.dataHora}?`,
      'Voltar',
      '',
      'Excluir',
      deleteAction
    );
  }

  openResultDialog(result) {
    if (!result.idAgendProvisorio) {
      return;
    }
    this.result = result;
    this.openResultDialogFlag = true;
  }

  closeResultDialog() {
    this.result = null;
    this.openResultDialogFlag = false;
  }

  openPlanningResultDialog(result) {
    this.result = result;
    this.formPlanningOpen = true;
    this.openResultDialogFlag = false;
  }

  onCloseFormPlanning() {
    this.formPlanningOpen = false;
  }

  onAfterSavePlanning() {
    this.formPlanningOpen = false;
  }
}
